
import { useRef, useEffect } from 'react';

export const useIfMounted = () => {
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;
    }, [ ]);

    return isMounted.current;
};